import React from 'react';
import {Redirect} from 'react-router-dom';
import {SessionManager} from "../session-manager";

export class Logout extends React.Component {
    constructor(props) {
        super(props);

        SessionManager.logout();
    }

    render() {
        return <Redirect to="/login"/>
    }
}